import { defineComponent as t, openBlock as n, createBlock as r, unref as l, mergeProps as p, withCtx as m, createElementVNode as h } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const s = /* @__PURE__ */ t({
  name: "IconShop",
  __name: "IconShop",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (n(), r(l(c), p(o, { "view-box": "0 0 24 24" }), {
      default: m(() => [...e[0] || (e[0] = [
        h("path", {
          "fill-rule": "evenodd",
          d: "M3.25 11.192a1.25 1.25 0 0 1-.84-1.473L3.5 4.994A2.25 2.25 0 0 1 5.694 3.25h12.614A2.25 2.25 0 0 1 20.5 4.994l1.09 4.725a1.25 1.25 0 0 1-.84 1.473V18.5a2.25 2.25 0 0 1-2.25 2.25H15a1.25 1.25 0 0 1-1.25-1.25V16a1.75 1.75 0 1 0-3.5 0v3.5A1.25 1.25 0 0 1 9 20.75H5.5a2.25 2.25 0 0 1-2.25-2.25v-7.308M9.685 4.75 9.296 9.025l.833.357a4.75 4.75 0 0 0 3.742 0l.833-.357-.39-4.275h-4.63m-2.11 6.051.95-.475.013.006 1 .429a6.25 6.25 0 0 0 4.924 0l1-.429.014-.006.95.475a4.25 4.25 0 0 0 1.9.449h.924v7.25a.75.75 0 0 1-.75.75h-3.25V16a3.25 3.25 0 0 0-6.5 0v3.25H5.5a.75.75 0 0 1-.75-.75v-7.25h.924a4.25 4.25 0 0 0 1.9-.449M7.79 9.016 8.179 4.75H5.693a.75.75 0 0 0-.73.581L3.942 9.75h1.73a2.75 2.75 0 0 0 1.23-.29L7.79 9.016m9.305.444L16.21 9.016 15.82 4.75h2.486a.75.75 0 0 1 .73.581l1.02 4.419h-1.73a2.75 2.75 0 0 1-1.23-.29",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
